import * as React from 'react';

/**
 * Skip SSR for the wrapped tree.
 */
export function NoSSR(props: { children: React.ReactNode }): React.ReactElement | null {
    const { children } = props;
    const [mounted, setMounted] = React.useState(false);

    React.useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    return <>{children}</>;
}
